import React from 'react';

const PayloadList = ({ payload }) => {
  if (!payload || typeof payload !== 'object') return null;

  const fieldLabels = {
    privateWeapons: 'Armas particulares',
    weaponNumber: 'Número da arma',
    species: 'Espécie',
    caliber: 'Calibre',
    sinarm: 'SINARM',
    trainings: 'Formação e aperfeiçoamento',
    courseName: 'Nome do curso',
    workload: 'Duração',
    startDate: 'Data de início',
    dateConclusion: 'Data de conclusão',
    dateExpedition: 'Expedição do certificado',
    dateExpiration: 'Data de validade',
    related: 'Atualização/Renovação',
    relatedItemId: 'Item relacionado',
  };

  const operationLabels = {
    add: 'Adicionar',
    update: 'Alterar',
    remove: 'Excluir',
    delete: 'Excluir',
  };

  if (Object.keys(payload).includes('_noChanges')) {
    return (
      <div className="py-1">
        Não foram feitas alterações em <strong>{payload['_noChanges']}</strong>
      </div>
    );
  }

  const isJson = (str) => {
    if (typeof str !== 'string' || !isNaN(parseInt(str))) return false;
    try {
      const parsed = JSON.parse(str);
      return typeof parsed === 'object';
    } catch (e) {
      return false;
    }
  };

  return (
    <div className="flex flex-col gap-1 ml-4 pl-2 text-sm">
      {Object.keys(payload).filter(key => key !== 'keys').map((key, index) => {
        const keyText = fieldLabels[key] ?? (isNaN(key) ? key : `Item ${parseInt(key) + 1}`);
        let value = payload[key];

        if (value === 't' || value === 'true' || value === true) value = true;
        if (value === 'f' || value === 'false' || value === false) value = false;

        if (key === 'operation') {
          return (
            <div key={index}>
              <strong>• Operação:</strong> {operationLabels[value] ?? value}
            </div>
          );
        }

        if (key === 'value' && typeof value === 'object' && value !== null) {
          return <PayloadList key={index} payload={value} />;
        }

        if (typeof value === 'boolean') {
          return (
            <div key={index}>
              <strong>• {keyText}:</strong> {value ? 'Sim' : 'Não'}
            </div>
          );
        }

        if (typeof value === 'object' && value !== null) {

          if (Array.isArray(value) && value.every(v => typeof v !== 'object')) {
            return (
              <div key={index}>
                <strong>• {keyText}:</strong> {value.length ? value.join(', ') : '[vazio]'}
              </div>
            );
          }

          return (
            <div key={index}>
              <strong>{keyText}:</strong>
              <PayloadList payload={value} />
            </div>
          );
        }

        if (isJson(value)) {
          return (
            <div key={index}>
              <strong>{keyText}:</strong>
              <PayloadList payload={JSON.parse(value)} />
            </div>
          );
        }

        return (
          <div key={index}>
            <strong>• {keyText}:</strong> {value?.toString() || '[vazio]'}
          </div>
        );
      })}
    </div>
  );
};

export default PayloadList;